// js/ui/header.js
// SINGLE-SOURCE marketing site header — one header for every public page (index/start/help) so the
// brand reads continuous across the marketing surface.
//
// Mount point (per page):  <div id="siteHeader" [data-variant="dark"]></div>
//   default        — navy logo + dark nav, for pages on a LIGHT hero (index/start).
//   variant="dark" — white logo + light nav, for pages on a DARK hero (help).
//
// POST WEB-FLIP scope: the authed app is the React client at /app, so the header's old "app" skin
// (avatar menu, prices pill, Add-account, sign-out via window.NS_AUTH, unified footer) is gone with
// the authed HTML pages it served. What remains is the marketing bar: logo + marketing nav + Log in /
// Get started, both pointing at the app (/app). No user data is interpolated, so there is no auth
// dependency and nothing to escape.

(function () {
  // Same glyph in two fills so it reads on either hero: navy on light, white on dark.
  const STAR_DARK = '<svg width="26" height="26" viewBox="0 0 32 32" fill="none" aria-hidden="true"><path d="M16 2 L18.8 13.2 L30 16 L18.8 18.8 L16 30 L13.2 18.8 L2 16 L13.2 13.2 Z" fill="#0f1e45"/><circle cx="16" cy="16" r="2.8" fill="#fff"/></svg>';
  const STAR_LIGHT = '<svg width="26" height="26" viewBox="0 0 32 32" fill="none" aria-hidden="true"><path d="M16 2 L18.8 13.2 L30 16 L18.8 18.8 L16 30 L13.2 18.8 L2 16 L13.2 13.2 Z" fill="#fff"/><circle cx="16" cy="16" r="2.8" fill="rgba(15,30,69,0.5)"/></svg>';

  injectStyles();
  renderHeader();

  function renderHeader() {
    const host = document.getElementById('siteHeader');
    if (!host) return;
    host.innerHTML = marketingHeader(host.dataset.variant === 'dark');
  }

  // Transparent over the hero; both CTAs go to the app at /app. `dark` swaps the logo + nav colours
  // for a dark background (help); the purple Get-started button reads on either.
  function marketingHeader(dark) {
    return `<div class="shBar shBar--marketing${dark ? ' shBar--onDark' : ''}">
        <a href="index.html" class="shLogo">${dark ? STAR_LIGHT : STAR_DARK}<span>Northstar</span></a>
        <nav class="shNav shNav--marketing" aria-label="Primary">
          <a href="index.html" class="shNavItem">How it works</a>
          <a href="start.html" class="shNavItem">New to investing</a>
          <a href="help.html" class="shNavItem">Guides</a>
        </nav>
        <div class="shRight">
          <a href="/app" class="shMktLogin">Log in</a>
          <a href="/app" class="shMktBtn">Get started</a>
        </div>
      </div>`;
  }

  // Scoped styles (self-contained: identical on pages that skip the shared styles.css).
  function injectStyles() {
    if (document.getElementById('siteChromeStyles')) return;
    const s = document.createElement('style');
    s.id = 'siteChromeStyles';
    s.textContent = `
      #siteHeader { position: relative; z-index: 10; display: block; }
      .shBar { display: flex; align-items: center; justify-content: space-between; gap: 16px; height: 68px; padding: 0 30px; }
      .shLogo { display: flex; align-items: center; gap: 9px; text-decoration: none; flex-shrink: 0; }
      .shLogo span { font-size: 17px; font-weight: 900; color: var(--ink, #0f1e45); letter-spacing: -.3px; }
      /* Reset: the inner <nav> must not inherit the pages' global nav{} bar styling
         (background/height/border/blur) — that would draw a second block behind the items. */
      .shNav { display: flex; align-items: center; gap: 6px; position: static; height: auto; min-height: 0; margin: 0; padding: 0; background: none; border: 0; box-shadow: none; -webkit-backdrop-filter: none; backdrop-filter: none; }
      .shNavItem { text-decoration: none; font-size: 14px; font-weight: 600; color: var(--muted, #6b7897); padding: 8px 14px; border-radius: 9px; white-space: nowrap; transition: background .12s, color .12s; }
      .shNavItem:hover { color: var(--text, #0f1e45); background: rgba(15,30,69,.05); }
      .shRight { display: flex; align-items: center; gap: 16px; }
      .shMktLogin { text-decoration: none; font-size: 14px; font-weight: 600; color: var(--text, #0f1e45); padding: 8px 12px; white-space: nowrap; }
      .shMktLogin:hover { color: var(--accent-strong, #5b4fcf); }
      /* accent-strong (not accent) as the base so white text clears WCAG AA (6.06:1 vs 4.31:1) on
         every hero — the per-page overrides that used to patch this are now redundant. */
      .shMktBtn { display: inline-flex; align-items: center; gap: 6px; text-decoration: none; font-size: 14px; font-weight: 700; color: #fff; background: var(--accent-strong, #5b4fcf); border-radius: 11px; padding: 9px 17px; box-shadow: 0 6px 16px rgba(108,99,255,.28); white-space: nowrap; transition: filter .12s; }
      .shMktBtn:hover { filter: brightness(0.93); }
      /* Dark-hero variant (help): white logo + light nav, translucent hover. */
      .shBar--onDark .shLogo span { color: #fff; }
      .shBar--onDark .shNavItem { color: rgba(255,255,255,.72); }
      .shBar--onDark .shNavItem:hover { color: #fff; background: rgba(255,255,255,.1); }
      .shBar--onDark .shMktLogin { color: rgba(255,255,255,.92); }
      .shBar--onDark .shMktLogin:hover { color: #fff; }
      @media (max-width: 640px) {
        .shBar { padding: 0 16px; gap: 10px; }
        .shNav--marketing { display: none; }
      }`;
    document.head.appendChild(s);
  }
})();
